export default "__VITE_ASSET__f3111d4e__"